export default {
  /**
   * Estado do usuário.
   * @property {String} name (computed)
   * @property {String} firstName
   * @property {String} surname
   * @property {String} id
   * @property {String} language
   * @property {String} email
   * @property {Boolean} nightMode
   * @property {String} fontSize
   * @property {String} username
   * @property {Boolean} receiveEmailAlerts
   * @property {Boolean} receiveSmsAlerts
   * @property {String} timeZoneId
   * @property {Boolean} feedbackButton
   */
  user: null,
  token: null,
  /**
   * Dados de acesso temporário.
   * @property {Boolean} needsRedefinePassword
   * @property {Boolean} licenseAccepted
   * @property {Boolean} hasSecretQuestion
   */
  temporaryAccessData: null,
  /**
   * Estado da recuperação de senha.
   * @property {Boolean} email
   * @property {Boolean} username
   * @property {String} secretQuestion
   */
  recoverData: null,
  // Pendencias de acesso, como, por exemplo, licenciamento ou acesso temporário.
  accessPending: [],
  // Indica se o refresh token expirou, ou se não foi possível renová-lo.
  isRefreshTokenExpired: false,
  /**
   * Data e hora de expiração do refresh token.
   */
  refreshTokenExpiration: null,
};
